import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from "@angular/core";
import { DataElement, ProcessRunStatusEnum, ProcessRunStatusResult, ReferencePhrase } from "@shared/models/common";
import { ClaimToolElement } from "@shared/models/claim-tool-element.model";
import { NgRedux } from "@shared/redux/redux-compatibility.service";
import { actionsList, AppState } from "@shared/redux/store";
import { AssocPhrasesRequest } from "@shared/models/assoc-phrases-request";
import { filter} from "rxjs/operators";
import { ClaimToolService } from "@shared/services/claim-tool.service";
import { SharedService } from "@shared/services/shared.service";
import { ReferenceOptionsRequest } from "@shared/models/reference-options-request.model";
import { DocPhraseMergeAndReorderRequest } from "@shared/models/doc-phrase-merge-and-reorder.request";
import { TreeNode } from "primeng/api";
import { Popover } from "primeng/popover";
import { AssocImagesRequest } from "@shared/models/assoc-images-request";
import { GenaiModificationResponse } from "@shared/models/gen-ai-modification.model";
import { TreeNodeUnSelectEvent } from "primeng/tree";
import { ReevalJobService } from "@shared/services/reeval-job.service";
import { ReevalJobTarget } from "@shared/models/reeval-job.model";
import { getObjectPropValue } from "@shared/utils";


@Component({
    selector: 'claim-tool',
    templateUrl: './claim-tool.component.html',
    styleUrls: ['./claim-tool.component.scss'],
    providers: [ClaimToolService],
    standalone: false
})
export class ClaimToolComponent implements OnInit {

  @Input("claim") claimToolElement: ClaimToolElement = null;
  @Input() presentation: 'dialog' | 'embedded' = 'dialog';
  @Output() saved = new EventEmitter<void>();
  @Output() returnToDetails = new EventEmitter<void>();

  @ViewChild('save', { static: true }) headerActions!: TemplateRef<unknown>;
  @Output() onClose = new EventEmitter();
  @Output() showDetailsDialogEmitter = new EventEmitter();
  @ViewChild('opTypes') typesOverlay: Popover;
  @ViewChild('overlay') contentTypesOverlay: Popover;

  displayRefOptions: boolean = false;
  displayAssocTextOptions: boolean;
  displayAssocImagesOptions: boolean;
  currentIndex: number;
  assocPhrasesRequest: AssocPhrasesRequest;
  assocImagesRequest: AssocImagesRequest;
  referenceOptionsRequest: ReferenceOptionsRequest;
  docPhraseMergeAndReorderRequest: DocPhraseMergeAndReorderRequest;
  loadingContentTypes = false;
  //isModalDialogOpened = true;
  isLoading = false;
  contentTypeOptions: DataElement[] = [];
  mergeAndReorder: boolean = false;
  splitPhrases: boolean = false;
  phraseTypesTree: TreeNode[] = [];
  selectedPhraseType: TreeNode | undefined;
  mergeOrSplitExecuted = false;
  mergeExecuted = false;
  splitExecuted = false;
  genaiPhraseMerged = false;
  genaiDetectClaim = false;
  hasAssocImageOptions = true;
  claimToolLabel: string = 'translate.claim.tool';
  enforceOperationDependencies: boolean = false;
  shouldReturnToDetailsAfterSave: boolean = false;
  constructor(private ngRedux: NgRedux<AppState>, 
    private claimToolService: ClaimToolService,
    private sharedService: SharedService,
    private reevalJobService: ReevalJobService
  ) {}

  get reevalTarget(): ReevalJobTarget {
    return {
      kind: this.claimToolElement.isPrecheck ? 'REV' : 'CAT',
      docId: this.claimToolElement.docId,
      elementId: this.claimToolElement.phraseId,
      isImage: false,
      stateTag: this.claimToolElement.stateTag
    };
  }

  ngOnInit(): void {

     this.claimToolService
      .generateModifications(this.claimToolElement.docId, this.claimToolElement.phraseId, this.claimToolElement.isPrecheck)
      .subscribe({
        next: (res: GenaiModificationResponse) => {
          this.genaiPhraseMerged = res.has_merge_phrase;
          this.genaiDetectClaim = res.has_detect_claim;
        },
        error: (err) => {
          console.error('Error calling generateModifications:', err);
        }
      });
      if (this.claimToolElement.contentType == 'TEXT_CONTENT') {

        this.claimToolLabel = 'translate.text.tool';
      }

    this.referenceOptionsRequest = {
      doc_id: this.claimToolElement.docId,
      is_precheck: this.claimToolElement.isPrecheck,
      phrase_id: this.claimToolElement.phraseId
    }
    this.assocPhrasesRequest = {
        doc_id: this.claimToolElement.docId,
        is_precheck: this.claimToolElement.isPrecheck,
        phrase_id: this.claimToolElement.phraseId
  
      }
    this.assocImagesRequest = {
      doc_id: this.claimToolElement.docId,
      is_precheck: this.claimToolElement.isPrecheck,
      phrase_id: this.claimToolElement.phraseId
    }
      this.docPhraseMergeAndReorderRequest = {
        doc_id: this.claimToolElement.docId,
        is_precheck: this.claimToolElement.isPrecheck,
        page_num: this.claimToolElement.pageNum
      }
      this.contentTypeOptions = this.ngRedux.getState().contentTypeList;

        this.initCatTypesTree();
      
      this.claimToolService.mergedPhrasesChanged$.subscribe((mergeChanged) => {
          
        this.mergeExecuted = mergeChanged;
        this.mergeOrSplitExecuted = this.mergeExecuted || this.splitExecuted;
      })
      this.claimToolService.splitWordsChanged$.subscribe((splitChanged) => {
        this.splitExecuted = splitChanged;
        this.mergeOrSplitExecuted = this.mergeExecuted || this.splitExecuted;
      });
      /*
      if (this.contentTypeOptions == null) {
        this.loadingContentTypes = true;
        this.claimToolService.getContentTypeOptions().subscribe((contentTypeOptions) => {
          this.contentTypeOptions = contentTypeOptions;
          this.selectedContentType = this.contentTypeOptions.find(option => option.id === this.claimToolElement.contentType);
          this.loadingContentTypes = false;
        },
        () => {
          this.loadingContentTypes = false;
        }
        )
      } else {
        this.selectedContentType = this.contentTypeOptions.find(option => option.id === this.claimToolElement.contentType);
      }
        */
    const uiConfig = this.ngRedux.getState().uiConfig;
    if (uiConfig) {

      this.enforceOperationDependencies = getObjectPropValue(uiConfig, 'claim_tool.enforce_operations_dependencies') ?? true; 
      this.shouldReturnToDetailsAfterSave = getObjectPropValue(uiConfig, 'claim_tool.should_return_to_phrase_details') ?? false;

    } 
   }

  get claimToolSaveChangesDataInitialValues() {

    return this.ngRedux.getState().claimToolSaveChangesDataInitialValues;
  }

  close() {
    this.onClose.emit();
  }



  onDeleteRef(ref: ReferencePhrase) {

    ref.deleteSw = true;
    this.claimToolElement.deletedReferences.push(ref);
    this.claimToolElement.references.splice(this.claimToolElement.references.indexOf(ref), 1);
  }


  
  saveChanges() {
     this.isLoading = true;

    if (this.reevalJobService.isAsyncEnabled()) {
      this.claimToolService.submitChanges(this.claimToolElement, this.claimToolSaveChangesDataInitialValues).subscribe(
        (runNum: number) => {
          this.reevalJobService.startJob(runNum, this.reevalTarget);
          this.onChangesSaved();
        },
        (error) => this.onSaveChangesError(error)
      );
      return;
    }

    this.claimToolService.saveChanges(this.claimToolElement, this.claimToolSaveChangesDataInitialValues)
      .pipe(filter((processRunStatus: ProcessRunStatusResult) => processRunStatus.status == ProcessRunStatusEnum.FINISHED))
      .subscribe(
        () => this.onChangesSaved(),
        (error) => this.onSaveChangesError(error)
      );
  }

  private onChangesSaved() {
    

    if (this.presentation === 'dialog' || (this.presentation === 'embedded' && !this.shouldReturnToDetailsAfterSave)) {
    this.ngRedux.dispatch({
      type: actionsList.RELOAD_CAT_DOC_PAGE_REQ,
      data: false,
    });

    this.ngRedux.dispatch({
      type: actionsList.REMOVE_CURRENT_ANNOTATIONS
    });
    this.ngRedux.dispatch({
      type: actionsList.GET_REV_DOC_CARDS_START
    });


  } else if (this.presentation === 'embedded' && this.shouldReturnToDetailsAfterSave) {
      
      this.saved.emit();
    }

    //this.isLoading = false;
  }

  private onSaveChangesError(error: any) {
    this.isLoading = false;
    this.onClose.emit();
    console.error("Error saving changes", error);
    this.sharedService.showInfoMessage({
      messageKey: "translate.error.claim-tool.save.changes",
      infoType: "error"
    });
  }

  showDetailsDialog() {

    this.showDetailsDialogEmitter.next();

  }



  changeType(selectedItem: DataElement) {
    
    if (this.enforceOperationDependencies && this.mergeOrSplitExecuted) {
      return;
    } 
    
    this.claimToolElement.contentType = selectedItem.id;
    this.claimToolElement.contentTypeDesc = selectedItem.text;

    this.claimToolService.contentTypeChanged$.next(this.claimToolElement.contentType != this.claimToolSaveChangesDataInitialValues.contentType);
  
    // revert changes from Manage Context if type not claim and not footnote
    if (!(this.claimToolElement.contentType == 'CLAIM') && !(this.claimToolElement.contentType == 'FOOTNOTE')) {

        this.claimToolElement.references = JSON.parse(JSON.stringify(this.claimToolSaveChangesDataInitialValues.references));
        this.claimToolService.manageContextChanged$.next(false);
    }
    // revert changes from Manage Content if type not claim
    if (!(this.claimToolElement.contentType == 'CLAIM')) {

      this.claimToolElement.associatedText = JSON.parse(JSON.stringify(this.claimToolSaveChangesDataInitialValues.associatedText));
      this.claimToolService.manageContentChanged$.next(false);
    }
    this.contentTypesOverlay.hide();
    

  }
 initCatTypesTree() {
 if (this.claimToolElement.phraseTypeCode && this.claimToolElement.phraseSubTypeCode) {
      this.phraseTypesTree = this.ngRedux
        .getState()
        .catPhraseTypeModel?.getTreeBySelectedType(
          this.claimToolElement.phraseTypeCode,
          this.claimToolElement.phraseSubTypeCode
        ) || [];
      this.selectedPhraseType = this.ngRedux
        .getState()
        .catPhraseTypeModel?.getSubTypeNode(
          this.phraseTypesTree,
          this.claimToolElement.phraseTypeCode,
          this.claimToolElement.phraseSubTypeCode
        ) || undefined;
    } else {
      this.phraseTypesTree =
        this.ngRedux.getState().catPhraseTypeModel?.treeTypesForInput || [];
    }
  }
  onTypeSelected(event: any) {
    if (this.mergeOrSplitExecuted) {
      return;
    } 

    this.claimToolElement.phraseTypeCode = this.selectedPhraseType.parent.key;
    this.claimToolElement.phraseTypeCodeDescr = this.selectedPhraseType.parent.label;
    this.claimToolElement.phraseSubTypeCode = this.selectedPhraseType.key;
    this.claimToolElement.phraseSubTypeCodeDescr = this.selectedPhraseType.label;
    //this.initCatTypesTree();
    if (this.typesOverlay) {
      this.typesOverlay.hide();
    }
    let changedCategory = (this.claimToolElement.phraseTypeCode != this.claimToolSaveChangesDataInitialValues.phraseTypeCode) || 
    (this.claimToolElement.phraseSubTypeCode != this.claimToolSaveChangesDataInitialValues.phraseSubTypeCode);
    this.claimToolService.phraseTypeCodeChanged$.next(changedCategory);
  }
  nodeUnselect(event: TreeNodeUnSelectEvent) {
    // Reset selected phrase type if unselected
    if (this.mergeOrSplitExecuted) {
      return;
    }
    if (this.claimToolSaveChangesDataInitialValues.phraseTypeCode == null) {
        setTimeout( () => {
        this.selectedPhraseType = event.node;
        this.selectedPhraseType.checked = true;

        this.claimToolElement.phraseTypeCode = this.selectedPhraseType.parent.key;
        this.claimToolElement.phraseTypeCodeDescr = this.selectedPhraseType.parent.label;
        this.claimToolElement.phraseSubTypeCode = this.selectedPhraseType.key;
        this.claimToolElement.phraseSubTypeCodeDescr = this.selectedPhraseType.label;
        this.checkPhraseTypeCodeChanged();
        })
      
    } else {
      setTimeout(() => {

        this.claimToolElement.phraseTypeCode = this.claimToolSaveChangesDataInitialValues.phraseTypeCode;
        this.claimToolElement.phraseSubTypeCode = this.claimToolSaveChangesDataInitialValues.phraseSubTypeCode;
        this.claimToolElement.phraseTypeCodeDescr = this.claimToolSaveChangesDataInitialValues.phraseTypeCodeDescr;
        this.claimToolElement.phraseSubTypeCodeDescr = this.claimToolSaveChangesDataInitialValues.phraseSubTypeCodeDescr;
        this.initCatTypesTree();
        this.checkPhraseTypeCodeChanged();
      })
    }


  }
  checkPhraseTypeCodeChanged() {
    let changedCategory = (this.claimToolElement.phraseTypeCode != this.claimToolSaveChangesDataInitialValues.phraseTypeCode) || 
    (this.claimToolElement.phraseSubTypeCode != this.claimToolSaveChangesDataInitialValues.phraseSubTypeCode);
    this.claimToolService.phraseTypeCodeChanged$.next(changedCategory);
  }

  onHasAssocImageOptionsChange(hasOptions: boolean) {
    this.hasAssocImageOptions = hasOptions;
    if (!hasOptions) {
      this.displayAssocImagesOptions = false;
    }
  }
}